import { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import Config from '@/config';
import { PROXY_URL_EXCLUDE } from '@/helper/constants';

class Proxy {
  private isProxied: boolean;

  constructor(url: string) {
    this.isProxied = PROXY_URL_EXCLUDE.every((item) => !url.startsWith(item));
  }

  config(config: AxiosRequestConfig): AxiosRequestConfig {
    if (!this.isProxied) return config;

    const data = config.data;
    config.data = {
      url: config.url,
      headers: config.headers,
      data,
    };
    config.headers = {};

    const urlObj = new URL(config.url);
    const urlPath = urlObj.pathname + urlObj.search;

    // extra request flag
    const requestFlag = (config as any)._requestFlag;
    const flagParam = requestFlag ? `_f=${requestFlag}&` : '';

    config.url = `${
      Config.H5_SERVICE.URL
    }/api/proxy/${config.method.toLowerCase()}?${flagParam}_u=${urlPath}`;
    config.method = 'post';

    // clean custom fields, avoid passing to axios
    delete (config as any)._requestFlag;

    return config;
  }

  success(response: AxiosResponse): AxiosResponse {
    if (!this.isProxied) return response;

    response = { ...response, ...response.data.data };
    return response;
  }

  error(error: AxiosError): AxiosError {
    if (!this.isProxied) return error;

    const response = error?.response;
    const responseData = response?.data as any;

    if (responseData?.code == '20005') {
      const factResponse = responseData?.error?.response;
      error.response = {
        ...error.response,
        ...factResponse,
      };
    }

    return error;
  }
}
export default Proxy;
